
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'NotificationsHeader'
})
export default class extends Vue {
}
